import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px;
  gap: 16px;

  .warning-banner {
    align-self: flex-end;
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  gap: 16px;

  > div {
    width: 50%;
  }
`

export const LoaderContainer = styled.div`
  position: relative;
  height: 100%;
  .loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
